import { render, staticRenderFns } from "./submitReview.vue?vue&type=template&id=607d3b9c&scoped=true&"
import script from "./submitReview.vue?vue&type=script&lang=js&"
export * from "./submitReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d3b9c",
  null
  
)

export default component.exports